export default "__VITE_ASSET__BLGiypaL__"